import React from 'react';
import { PopoverProps } from 'antd/lib/popover';

import { Popover as $Popover } from '../components/common/antd/antd-override';
interface ExtendedPopoverProps extends PopoverProps {
  open?: boolean;
}

export default function Popover({ children, overlayInnerStyle, ...props }: ExtendedPopoverProps) {
  return (
    <$Popover {...props} overlayInnerStyle={overlayInnerStyle}>
      {children}
    </$Popover>
  );
}
